import PropTypes from 'prop-types';
import ArticleParagraph from './articleParagraph';
import {Submit as ButtonMore} from 'ui';
import {Container, BackLink, Image, MainTitle, ArticleCover, Mask, ArticleContent} from './styles';

const BaseArticle = ({history, data}) => {
  const handleClick = () => history.push(`/articles`);
  // console.log(data);

  return (
    <Container>
      <ArticleCover>
        <Image src={data.acf.header_image} />
        <BackLink to="/articles" />
        <MainTitle>{data.acf.header_titre}</MainTitle>
        <Mask />
      </ArticleCover>

      <ArticleContent>
        {data.acf.articles_paragraphes.map((paragraph, id) => (
          // eslint-disable-next-line react/no-array-index-key
          <ArticleParagraph key={id} title={paragraph.articles_titre} text={paragraph.articles_texte} />
        ))}
      </ArticleContent>

      <ButtonMore onClick={handleClick}>Voir plus d’articles</ButtonMore>
    </Container>
  );
};

BaseArticle.propTypes = {
  data: PropTypes.object,
  history: PropTypes.object.isRequired,
  //  id: PropTypes.string,
  //  match: PropTypes.object.isRequired,
};

export default BaseArticle;
